module.exports = __webpack_public_path__ + "lp/img/img_teacher_01.db1a3e2c.svg";